const trackEvent = (eventName, params = {}) => {
  if (!window.gtag) return;

  window.gtag("event", eventName, {
    ...params,
  });
};

export default trackEvent;